export const blockIconsEditorShowChart = (
	<span className='material-symbols-outlined'>show_chart</span>
);
